import { Fragment, useContext } from 'react';
import { history, useLocation, useParams } from 'umi';
import Context from '@/utils/context';
import { useIntl } from 'react-intl';
import { Row, Col } from 'antd';
import { Form, message } from 'iglooform';
import throttle from 'lodash/throttle';
import { setPaymentPassword } from '../../service';
import { BackButton } from '@/components/back-button/back-button';
import { HeaderTitle } from '@/components/header-title/header-title';
import { aesDecrypt } from '@/utils/common';
import { payNumberReg } from '@/utils/regexp';

const SetPaymentPassword = () => {
  const form = Form.useForm();
  const { formatMessage } = useIntl();
  const { isPc } = useContext(Context);
  const { pathname }: any = useLocation();
  const { pay_pass }: any = useParams();

  const handlePaymentPassword = throttle(
    async (): Promise<void> => {
      // 是否是修改Payment Password，如果是，则需要获取上一个页面的原payment password参数
      const isChangePaymentPassword = pathname.includes(
        '/me/change-password/reset',
      );
      let old_payment_password = '';
      if (isChangePaymentPassword) {
        old_payment_password = aesDecrypt(pay_pass); // 解密payment password
      }
      try {
        const values = await form.validateFields();
        setPaymentPassword({
          old_payment_password: old_payment_password,
          payment_password: values.payment_password.trim(),
        }).then((res) => {
          if (res) {
            message.success(
              formatMessage({
                id: 'Set payment password successfully!',
              }),
            );
            history.replace('/home');
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    1000,
    { leading: true, trailing: false },
  );

  return (
    <Fragment>
      <BackButton handleClick={() => history.goBack()} />
      <Row style={isPc ? { marginTop: '40px' } : { marginTop: '24px' }}>
        <Col
          span={isPc ? 12 : 24}
          style={{ maxWidth: '538px', margin: '0 auto' }}
        >
          <HeaderTitle
            title={formatMessage({ id: 'Set Payment Password' })}
            subTitle={formatMessage({
              id: 'Create a payment password for critical transactions.',
            })}
          />
          <div>
            <Form
              form={form}
              config={{
                type: 'Login',
                elements: [
                  {
                    type: 'Password',
                    label: formatMessage({
                      id: 'Payment Password',
                      defaultMessage: 'Payment Password',
                    }),
                    name: 'payment_password',
                    fullRow: true,
                    required: true,
                    initialValue: '',
                    rules: [
                      {
                        validator: (rule: any, value: string) => {
                          const p = form.getFieldValue('confirmPinNumber');
                          if (!!value && !payNumberReg.test(value?.trim())) {
                            return Promise.reject(
                              new Error(
                                formatMessage({
                                  id: 'Payment password must be number!',
                                }),
                              ),
                            );
                          } else if (!!p && p !== value) {
                            return Promise.reject(
                              new Error(
                                formatMessage({
                                  id: 'The two payment password is inconsistent!',
                                }),
                              ),
                            );
                          } else {
                            return Promise.resolve();
                          }
                        },
                      },
                    ],
                    antdDependencies: ['confirmPinNumber'],
                  },
                  {
                    type: 'Password',
                    label: formatMessage({
                      id: 'Confirm Payment Password',
                      defaultMessage: 'Confirm Payment Password',
                    }),
                    name: 'confirmPinNumber',
                    fullRow: true,
                    required: true,
                    initialValue: '',
                    rules: [
                      {
                        validator: (rule: any, value: string) => {
                          const p = form.getFieldValue('payment_password');
                          if (!!value && p !== value) {
                            return Promise.reject(
                              new Error(
                                formatMessage({
                                  id: 'The two payment password is inconsistent!',
                                }),
                              ),
                            );
                          } else {
                            return Promise.resolve();
                          }
                        },
                      },
                    ],
                    antdDependencies: ['payment_password'],
                  },
                ],
              }}
              onSubmit={handlePaymentPassword}
              locales={{
                submitText: formatMessage({
                  id: 'Done',
                  defaultMessage: 'Done',
                }),
                validateMessages: {
                  required:
                    '${label} ' +
                    formatMessage({
                      id: 'is required',
                    }),
                },
              }}
            />
          </div>
        </Col>
      </Row>
    </Fragment>
  );
};

export default SetPaymentPassword;
